window.addEventListener('load', function() {
  document.body.classList.add('loaded');
});


document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(event) {
                event.preventDefault(); // デフォルトの動作を無効化
                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);

                if (targetElement) {
                    const headerHeight = document.querySelector('x-header.header').offsetHeight; // ヘッダーの高さを取得
                    const targetPosition = targetElement.offsetTop - headerHeight - 60; // ヘッダーの高さ分を引く

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth' // スムーズスクロール
                    });
                }
            });
        });